import SuggestedListSettings from './suggested-list-settings.jsx';
for ( const element of document.querySelectorAll('.suggested-list-settings') ) {
	wp.element.render( <SuggestedListSettings/>, element );
}

import ProfilePictureUpload from './profile-picture-upload.jsx';
for ( const element of document.querySelectorAll( '.profile-picture-upload' ) ) {
	wp.element.render(
			<ProfilePictureUpload maxUploadSize={element.dataset.maxUploadSize} pictureSrc={element.dataset.pictureSrc}/>,
		element
	);
}
